export default {"src":"/_next/static/media/canadalogo.34168719.svg","height":324,"width":923};